// A failed/empty period lookup is not an endless load, nor evidence of zero sales.
// All three reporting views share the same state and explicit recovery action.
export function ReportingPeriodsState({ loading, onRetry }: { loading: boolean; onRetry: () => void }) {
  return (
    <div className="catalog-empty" role="status">
      {loading ? 'Loading reporting periods…' : <>
        <p>No reporting periods available. Data is missing or could not be loaded.</p>
        <button type="button" onClick={onRetry}>Retry loading data</button>
      </>}
    </div>
  )
}
